<template>
  <div class="survivor-boundary">
    <!-- 1. The Safe State: Render Children -->
    <slot v-if="!error" />

    <!-- 2. The Error State: Render Fallback -->
    <div v-else class="survivor-fallback" :class="{ 'admin-debug': isAdmin }">
      <div class="icon">⚠️</div>
      <div class="message">
        <h4>Content Unavailable</h4>
        <p v-if="isAdmin">
          System Error: {{ error.message }}<br>
          Component: {{ componentName }}
        </p>
      </div>
      <button v-if="isAdmin" @click="resetError">Retry</button>
    </div>
  </div>
</template>

<script>
import { ref, onErrorCaptured } from 'vue';

export default {
  name: 'SurvivorBoundary',
  props: {
    componentName: { type: String, required: true },
    isAdmin: { type: Boolean, default: false }
  },
  setup(props) {
    const error = ref(null);

    // THE CORE LOGIC
    onErrorCaptured((err) => {
      console.error(`[Survivor] Trapped error in ${props.componentName}:`, err);
      
      // Update state to show fallback
      error.value = err;

      // STOP PROPAGATION (Critical!)
      // Returning false prevents the error from bubbling to App root and crashing the page.
      return false;
    });

    const resetError = () => {
      error.value = null;
    };

    return { error, resetError };
  }
};
</script>

<style scoped>
.survivor-fallback {
  padding: 20px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  text-align: center;
  margin: 10px 0;
}
.admin-debug {
  background: #fff3cd;
  border-color: #856404;
  color: #856404;
}
</style>
